import React from 'react'
import Herosection from '../Componet/Herosection/HerosectionL1'
import Counter from '../Componet/Feature/Counter'
// import Newsletter from '../Componet/Newsletter/NewsletterL1'
import Feauture from '../Componet/Feature/Feature';
import Blog from '../Componet/Blog/Blog';

function HomePage() {
  return (
    <div>
      <Herosection />
      <div className="page-content">
        <Feauture />
        <Counter />
        {/* <Newsletter /> */}
        <Blog/>
      </div>
    </div>
  )
}

export default HomePage
